module.exports = __webpack_public_path__ + "img/cover.39dc54b8.png";